import Vue from 'vue';
export const ConfirmationEvent = new Vue();